import services from "@/http/requests/service";

export default {
    fetch({ commit }, data) {
        return new Promise((resolve, reject) => {
            services.fetch(data.sortName, data.page, data.itemsPerPage, data.type, data.word)
            .then((response) => {
                const parsedData = response.data.data.getService;

                commit('SET_SERVICES', parsedData);
                resolve(response);
            })
            .catch ((exception) => {
                reject(exception);
            });
        });
    },
    create({ commit }, data) {
        return new Promise((resolve, reject) => {
            services.create(data)
            .then((response) => {
                const parsedData = response.data.data.createService;

                commit('CREATE_SERVICE', parsedData);
                resolve(response);
            })
            .catch ((exception) => {
                reject(exception);
            });
        });
    },
    update({ commit }, data) {
        return new Promise((resolve, reject) => {
            services.update(data)
            .then((response) => {
                const parsedData = response.data.data.updateService;

                commit('UPDATE_SERVICE', parsedData);
                resolve(response);
            })
            .catch ((exception) => {
                reject(exception);
            });
        });
    },
    delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            services.delete(id)
            .then((response) => {
                commit('DELETE_SERVICE', id);
                resolve(response);
            })
            .catch ((exception) => {
                reject(exception);
            });
        });
    }
}